<div id="brandList">
  <div class="optical-or-connected">
    <app-compatibility-card
      [class.active]="isOpticalSelected$ | async"
      (click)="onSelectOpticalIfTrue(true)"
    >
      <h3>
        {{ "compatibility.opticalSensor.title" | translate }}
      </h3>
      <h4>
        {{ "compatibility.opticalSensor.subtitle" | translate }}
      </h4>

      <div class="content-zone">
        <div class="optical-images">
          <img
            src="assets/images/compatibility/user-icon.png"
            alt="user icon"
          />
          <img
            src="assets/images/compatibility/light-icon.png"
            alt="light icon"
          />
          <img
            src="assets/images/compatibility/oblic-mobile-icon.png"
            alt="mobile icon"
          />
        </div>
      </div>
      <div class="btn-container">
        <button class="btn">
          <span>{{ "compatibility.opticalSensor.readMore" | translate }}</span>
          <span
            class="icon"
            [ngClass]="{
              'icon-arrow-up': (isOpticalSelected$ | async),
              'icon-arrow-down': (isOpticalSelected$ | async) !== true
            }"
          ></span>
        </button>
      </div>
    </app-compatibility-card>

    <div class="or-container">
      <span class="or">{{ "compatibility.or" | translate }}</span>
    </div>

    <app-compatibility-card
      [class.active]="(isOpticalSelected$ | async) !== true"
      (click)="onSelectOpticalIfTrue(false)"
    >
      <h3>{{ "compatibility.connectedMachine.title" | translate }}</h3>
      <h4>{{ "compatibility.connectedMachine.subtitle" | translate }}</h4>

      <div class="content-zone">
        <img
          class="brand-logos"
          [src]="
            'assets/images/compatibility/brand-logos' +
            ((isOpticalSelected$ | async) ? '' : '-blue') +
            '.png'
          "
          alt="brand-logos"
        />
      </div>
      <div class="btn-container">
        <button class="btn">
          <span>{{
            "compatibility.connectedMachine.selectBrand" | translate
          }}</span>
          <span
            class="icon"
            [ngClass]="{
              'icon-arrow-down': (isOpticalSelected$ | async),
              'icon-arrow-up': (isOpticalSelected$ | async) !== true
            }"
          ></span>
        </button>
      </div>
    </app-compatibility-card>
  </div>

  <app-brand-selection
    *ngIf="(isOpticalSelected$ | async) !== true; else opticalSensorTutorial"
  ></app-brand-selection>

  <ng-template #opticalSensorTutorial>
    <app-optical-sensor-tutorial></app-optical-sensor-tutorial>
  </ng-template>
</div>
